// extracted by mini-css-extract-plugin
export default {"logo":"uyKzZFx7E1xpHu8L0KFp"};